/** Split display name — last word in gold italic em slot (reference pattern). */
export function splitDisplayName(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return { main: "Creator", em: "" };
  if (parts.length === 1) return { main: parts[0], em: "" };
  return {
    main: parts.slice(0, -1).join(" "),
    em: parts[parts.length - 1],
  };
}

export function formatFeaturedLongDate(date = new Date()) {
  return date.toLocaleDateString("en-CA", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "America/Toronto",
  });
}

export function formatFeaturedShortDate(ts) {
  if (!ts) return "";
  const d = ts?.seconds ? new Date(ts.seconds * 1000) : ts instanceof Date ? ts : new Date(ts);
  return d.toLocaleDateString("en-CA", {
    month: "short",
    day: "numeric",
    timeZone: "America/Toronto",
  });
}

export function featuredTypeLabel(type) {
  if (type === "discovery") return "Discovery";
  if (type === "community") return "Community";
  return type || "Featured";
}

export function creatorCardImage(creator) {
  return (
    creator?.bannerImage ||
    creator?.bannerUrl ||
    creator?.cardImage ||
    creator?.avatarUrl ||
    creator?.avatar ||
    ""
  );
}

export function creatorProfilePath(creator) {
  const handle = creator?.handle || creator?.username;
  return handle ? `/creator/${handle}` : null;
}
